import { MatSnackBarConfig } from '@angular/material/snack-bar';

// Assertive und länger sichtbar: Die Meldung ist lang und fordert eine Folgehandlung,
// bei polite und 3 s geht sie nach dem Seitenwechsel leicht unter.
export const MAIL_NOT_DELIVERED_SNACKBAR: MatSnackBarConfig = {
  panelClass: 'snackbar-error',
  politeness: 'assertive',
  duration: 8000,
};
